<template lang="pug">
v-card
  v-card-title
    .d-flex.flex-column.align-center.w-100
      span Potencial Comercial
      span  por cliente (Venta)
  v-card-text
    .chart-wrap(style="position: relative; height: 240px; width: 100%")
      Pie(:chart-data="chartData" :chart-options="chartOptions" :chart-id="id" :styles="{position:'relative',height:'100%',width:'100%'}")
</template>

<script>
import { Pie } from 'vue-chartjs/legacy'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement  } from 'chart.js'
import chartsUtils from '@/utils/chartsUtils'
import { mapActions } from 'vuex'

ChartJS.register(Title, Tooltip, BarElement, CategoryScale, LinearScale, ArcElement, Legend)

export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    },
    projection: {
      type: Number,
      default: null,
    },
  },
  components: {
    Pie,
  },
  data() {
    return {
      id: this._uid.toString(),
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                return `${context.label} $${context.formattedValue}`
              }
            }
          }
        }
      },
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: chartsUtils.colors,
            hoverBackgroundColor: chartsUtils.colors
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['getProjectionByCutomersChart']),
    // Agrupa las etiquetas dejando como máximo `maxCompanies` empresas (las de
    // mayor valor) y sumando el resto en "Otros". Así la torta no se fragmenta
    // en decenas de rebanadas ilegibles cuando hay muchos clientes.
    groupTopN(labels, datasets, maxCompanies = 6) {
      if (!labels || labels.length <= maxCompanies) return { labels, datasets }

      // Valor total por etiqueta (suma de todos los datasets; en la torta suele ser 1).
      const totals = labels.map((_, i) =>
        datasets.reduce((acc, ds) => acc + (Number(ds[i]) || 0), 0)
      )
      const order = labels
        .map((_, i) => i)
        .sort((a, b) => totals[b] - totals[a])
      const keep = order.slice(0, maxCompanies)
      const rest = order.slice(maxCompanies)

      const newLabels = keep.map(i => labels[i]).concat('Otros')
      const newDatasets = datasets.map(ds => {
        const kept = keep.map(i => Number(ds[i]) || 0)
        const otros = rest.reduce((acc, i) => acc + (Number(ds[i]) || 0), 0)
        return kept.concat(otros)
      })
      return { labels: newLabels, datasets: newDatasets }
    },
    async fetchData() {
      const params = {
        ...this.filters,
        projection: this.projection || this.$route.params.id
      }
      const { data, error } = await this.getProjectionByCutomersChart(params)
      if (error || !data || !data.labels || !data.labels.length) {
        // Sin datos (o error de carga): dejar la torta vacía en vez de mostrar
        // los valores de ejemplo con los que se inicializó el componente.
        this.chartData = {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: chartsUtils.colors,
            hoverBackgroundColor: chartsUtils.colors
          }]
        }
        return
      }

      const grouped = this.groupTopN(data.labels, data.datasets, 6)

      this.chartData.labels = grouped.labels
      this.chartData.datasets = grouped.datasets.map((dataset) => ({
        data: dataset,
        backgroundColor: chartsUtils.colors,
        hoverBackgroundColor: chartsUtils.colors
      }))
      this.chartData = { ...this.chartData }
    }
  },
  watch: {
    filters: {
      handler() {
        this.fetchData()
      },
      deep: true,
    }
  },
  created() {
    this.fetchData()
  }
}
</script>
